// extracted by mini-css-extract-plugin
export default {"layout":"_3fff5db04d d93ef8e480 _50a4c313ec","h_slide":"_7a48469f4a","category":"d757736293 _13e1cfa1f1 f4830259e8"};